export default "__VITE_ASSET__Crsz$glh__"